var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 245,
    viewBox: "0 0 214 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.111 145.876C88.4104 151.006 63.4411 150.185 44.7063 144.868C25.7476 139.487 14.2589 129.888 12.1972 118.303C10.1356 106.718 17.5613 93.4848 33.4146 81.4154C49.0807 69.4885 72.1167 59.4444 98.817 54.3143C125.517 49.1842 150.487 50.0048 169.221 55.322C188.18 60.7028 199.669 70.3018 201.731 81.887C203.792 93.4722 196.366 106.705 180.513 118.775C164.847 130.702 141.811 140.746 115.111 145.876Z",
    stroke: "white",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.44 142.68C120.197 170.058 104.166 192.267 88.2882 206.082C72.1585 220.117 57.3104 224.62 46.7731 219.533C36.2359 214.445 29.9723 199.75 29.8933 177.89C29.8156 156.371 35.8122 129.318 48.0546 101.94C60.297 74.5614 76.3285 52.3526 92.2061 38.5372C108.336 24.5024 123.184 19.9998 133.721 25.0871C144.258 30.1744 150.522 44.8697 150.601 66.7299C150.679 88.2484 144.682 115.302 132.44 142.68Z",
    stroke: "white",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.36df7e9c6baad659fb955d3fcac028b4.svg";
export { ForwardRef as ReactComponent };